import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 调接口相当于ajax
// import axios from 'axios' //导入axios
// Vue.prototype.$axios = axios //修改原始数据


createApp(App).use(router).mount('#app')
